export default __webpack_public_path__ + "static/media/dg_banner_highlight.b7f0a7d2.png";